export const unsubscribeFromCustomerFlow = 'customer'
export const unsubscribeFromHomeDigestFlow = 'homeDigest'
export const unsubscribeFromHomeMarketFlow = 'homeMarket'
export const unsubscribeFromHomeownerEmailsFlow = 'homeownerEmails'
export const unsubscribeFromListingsFlow = 'listings'
